import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightningBolt: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconLightningBolt"><Path d="M12.6916 2.14995C13.4975 1.11413 15.1505 1.86168 14.9054 3.15093L13.6017 9.99956H17.4523C18.7004 9.99956 19.4029 11.4352 18.6369 12.4205L11.3029 21.8492C10.4969 22.8852 8.84363 22.1376 9.08903 20.8482L10.3927 13.9996H6.54215C5.29411 13.9994 4.59145 12.5639 5.35758 11.5787L12.6916 2.14995Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLightningBolt;
